import type { ColumnDef, DefaultSortState } from '@/shared/types/table-filters.types';
import type { RefereeQuestion } from '../types/referee-question.types';

/**
 * Questions are asked in the order configured for the referee, so that stays the
 * default order — not the generic "most recently updated first".
 */
export const REFEREE_QUESTION_DEFAULT_SORT: DefaultSortState = { key: 'sortOrder', dir: 'asc' };

/** Filterable/sortable referee question fields. */
export const refereeQuestionTableColumns: ColumnDef<RefereeQuestion>[] = [
  {
    key: 'text',
    label: 'Question',
    filterType: 'text',
    accessor: (question) => question.text,
    sortable: true,
  },
  {
    key: 'isRequired',
    label: 'Required',
    filterType: 'boolean',
    accessor: (question) => question.isRequired,
    sortable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    filterType: 'date-range',
    accessor: (question) => question.createdAt,
    sortable: true,
  },
];
